import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-power-usage',
  templateUrl: './power-usage.component.html',
  styleUrls: ['./power-usage.component.css']
})
export class PowerUsageComponent implements OnInit {

  constructor() { }

  @Input('uid') uid: any;
  @Input('stations') stations: any;

  ngOnInit() {
  }

  cal_power_usage(){
    var cal = 0;
    for(var i = 0;i < this.stations.length;i++){
      if(this.stations[i].current.length != 3){
        cal = cal + (((this.stations[i].current * this.stations[i].voltage)/1000));
      } else if(this.stations[i].current.length == 3){
        for(var j = 0;j < 3;j++){
          cal = cal + (((this.stations[i].current[j] * this.stations[i].voltage[j])/1000));
        }
      }
     
    }
    return cal.toFixed(2);
  }


  db1 = ['aqZ1OJhXM1xvZjYnmc5','1hcB73kqK19rpSTJLhD','kqnz74goB7lNrqKKwSU','Tn7GmlsWCyMzhH5UHFn','j3IcJkhtctzTUICUBEq'];
  db2 = ['w7hSW9qvwaWhep2y8h1','5B4XitBCdFu1WJnBkf7','tzqv2JQd8VXhbI9xMOR'];
  cal_power_usage_marq(db_name){
    var cal = 0;
    for(var i = 0;i < this.stations.length;i++){
      if(db_name == 1){
        if(this.db1.includes(this.stations[i].uid)){
          if(this.stations[i].current.length != 3){
            cal = cal + (((this.stations[i].current * this.stations[i].voltage)/1000));
          } else if(this.stations[i].current.length == 3){
            for(var j = 0;j < 3;j++){
              cal = cal + (((this.stations[i].current[j] * this.stations[i].voltage[j])/1000));
            }
          }
        }
      } else if(db_name == 2){
        if(this.db2.includes(this.stations[i].uid)){
          if(this.stations[i].current.length != 3){
            cal = cal + (((this.stations[i].current * this.stations[i].voltage)/1000));
          } else if(this.stations[i].current.length == 3){
            for(var j = 0;j < 3;j++){
              cal = cal + (((this.stations[i].current[j] * this.stations[i].voltage[j])/1000));
            }
          }
        }
      }
    }
    return cal.toFixed(2);
  }

  check_uid_in_array

}
